export const MAP_SETTINGS = {
    version: '2.1',
    apiKey: '36f3be2c-a5f0-46cc-bca2-9a013e69e300',
    lang: 'ru_RU',
    coordorder: 'latlong',
    coords: [56.49, 84.99],
    zoom: 13,
    controls: [],
    searchControlProvider: 'yandex#search',
};

export const DISPATCHER_DATA_REQUEST_INTERVAL = 10000;
